<template>
  <div class="ucrs-property__table">
    <div
      v-for="(feature, i) in extraFeatures"
      :key="i"
      class="ucrs-property__table-item"
    >
      <span class="ucrs-property__table-label">{{ feature.label }}:</span>
      <span
        v-dompurify-html="feature.value"
        class="ucrs-property__table-value"
      ></span>
    </div>
  </div>
</template>

<script>
import { extraFeatures } from '~/assets/js/computed'

export default {
  props: {
    property: {
      type: Object,
      default: () => {
        return null
      },
    },
  },
  computed: {
    extraFeatures,
  },
}
</script>

<style lang="postcss" scoped>
.ucrs-property__table {
  @apply flex flex-wrap;

  &-item {
    @apply w-1/2 text-sm py-5;

    &:nth-child(odd) {
      @apply pl-4 pr-2;
    }

    &:nth-child(even) {
      @apply pl-2 pr-4;
    }

    &:last-child:nth-child(odd) {
      @apply w-full pr-4;
    }

    @screen md {
      @apply flex gap-2;

      &:nth-child(odd),
      &:nth-child(even) {
        @apply pl-12 pr-4;
      }

      &:last-child:nth-child(odd) {
        @apply w-full;
      }
    }

    &:nth-child(4n + 1),
    &:nth-child(4n + 2) {
      @apply bg-white-dark;
    }
  }

  &-label {
    @apply whitespace-nowrap inline-block;
  }

  &-value {
    @apply inline-block font-bold;

    @screen md {
      @apply inline;
    }
  }
}
</style>
